define('CoaForm.Confirmation.View',
[
    'coa_confirmation.tpl',
    'underscore',
    'Backbone'
],
function (coa_confirmation,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: coa_confirmation

        , initialize: function (options) {
        }

        , getContext: function () {
            return {
            };
        }

    })
})
